export type Mods = Record<string, boolean | string | undefined>

export const classNames = (cls: string = '', mods: Mods = {}, additions: Array<string | undefined> = []) => [
    cls,
    ...additions.filter(Boolean),
    ...Object.entries(mods)
        .filter(([_, value]) => Boolean(value))
        .map(([className]) => className),
].join(' ')
